import { css } from '@emotion/react'
import styled from '@emotion/styled'

// import Button from '../../utils/Button';

import { Button } from '@mui/material';


export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const SubmitButton = styled(Button)`
  margin-top: 3rem;
  font-weight: 500;
  font-size: 1.8rem;
`

export const Legal = styled.span`
  display: block;
  margin-top: 3rem;
  color: #9B9B9F;
`

export const Title = styled.h1`
  margin-bottom: 2rem;
`

export const SubTitle = styled.h3`
  color: ${props => props.theme.colors.lightText};
  margin-bottom: 3rem;
`

export const LogoBox = styled.div`
  margin: 5rem auto;
  min-width: 20rem;
  max-width: 28rem;

  img {
    width: 100%;
    object-fit: contain;
  }
`